export const PASSWORD_PATTERN = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/;

export function validateNewPassword(value: string): string | null {
    const trimmed = value.trim();
    if (trimmed.length < 8) {
        return 'Password must be at least 8 characters';
    }
    if (!PASSWORD_PATTERN.test(trimmed)) {
        return 'Password must contain one digit, one lowercase, one uppercase, and one special character (@#$%^&+=)';
    }
    return null;
}
